module.exports = __webpack_public_path__ + "img/lianyun.e9264bcd.png";